export default {
		flashMessage(state) {
			return state.message;
		}
	}


// WEBPACK FOOTER //
// ./src/store/getters.js